import { render } from "./GridUtilizatorisiDrepturi.vue?vue&type=template&id=0e21b5fa&ts=true"
import script from "./GridUtilizatorisiDrepturi.vue?vue&type=script&lang=ts"
export * from "./GridUtilizatorisiDrepturi.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__